<!--<div class="margin-all-area">
  <div class="teamOfficeSection">
      <div class="teamOfficeBody" *ngIf="htmlText != ''">
          <iframe [src]="safeUrl" style="width: 100%; height:100vh; border: none; overflow: hidden;"></iframe>
      </div>
  </div>
</div>-->
<div *ngIf="htmlText != ''">
    <iframe *ngIf="safeUrl"  [src]="safeUrl" style="width: 100%; height:100vh; border: none; overflow: hidden;"></iframe>
</div>

<div class="loader-body" *ngIf="showSpinner">
    <div class="lds-ripple"><div></div><div></div></div>
</div>
